/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Administrator} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  administrator: Administrator
}

const AdministratorInfoCell: FC<Props> = ({administrator}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(administrator.id)
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {administrator.name}
        </a>
      </div>
    </div>
  )
}

export {AdministratorInfoCell}
